import React from "react"
import EnhancedFilterPanel from "./EnhancedFilterPanel"

const FilterPanel = (props) => {
  // Forward all props to the enhanced version
  return <EnhancedFilterPanel {...props} />
}

export default FilterPanel